import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from '../../components/panel/panel.jsx';
import axios from 'axios'
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import moment from 'moment/moment.js';
import OutboundIntegrationForm from './outboundIntegrationLog.jsx';
import { isEmpty } from '../../helper/helper.js';

function OutboundIntegrationLog({ props = {} }) {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({});
  const [formData, setFormData] = useState({
    currentPage: 1,
    rowsPerPage: 50,
    fromDate: moment().add(-3, 'days').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
  });
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')


  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const openForm = async (uid, e) => {
    e.preventDefault();
    setModalUid(uid)
    setFormIsOpen(true)

  }

  const refreshTable = async (_page, _size) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      shipmentNo: formData.shipmentNo ?? '',
      fromDate: formData.fromDate,
      toDate: formData.toDate,
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }

    await axios.get(`${window.API_HOST}/v1/integration-log-outbound`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  const searchForm = async () => {
    await refreshTable(1)
  }


  useEffect(() => {
    searchForm()
  }, []) //eslint-disable-next-line 


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '1500px'
    },
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Outbound Integration <small></small></h1>
      <Panel>
        <PanelHeader noButton>Outbound Integration Log</PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-4'>
              <div className="form-group row mb-0">
                <label className="col-sm-3 col-form-label text-left">Shipment Date</label>
                <div className="col-sm-4 ">
                  <input className="form-control form-control-sm" type="date" name="fromDate" onChange={handleOnChangeInputText} value={formData.fromDate ?? ""} />
                </div>
                <label className="col-sm-1 col-form-label text-center"> <span>to</span></label>
                <div className="col-sm-4">
                  <input className="form-control form-control-sm" type="date" name="toDate" onChange={handleOnChangeInputText} value={formData.toDate ?? ""} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Shipment No</label>
                <div className="col-sm-9">
                  <input type="text" name="shipmentNo" value={formData.shipmentNo ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => { }}><span className="fa fa-sm fa-download"></span> Download</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th>No.</th>
                  <th>Date Time</th>
                  <th>Shipment</th>
                  <th>Courier</th>
                  <th>Request Method</th>
                  <th>URL</th>
                  <th>Response Status</th>
                  <th>Creation Type</th>
                  <th>Txn Type</th>
                  <th>Count Retry</th>
                  <th>Max Retry</th>
                  <th>Last Retry</th>
                  <th>Success</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(dataTable).map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{moment(val.created_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td>{val.shipment_no}</td>
                      <td>{val.courier_code}</td>
                      <td>{val.request_method}</td>
                      <td>{val.url}</td>
                      <td>{val.response_status}</td>
                      <td>{val.creation_type}</td>
                      <td>{val.txn_type}</td>
                      <td>{val.count_attempt}</td>
                      <td>{val.max_attempt}</td>
                      <td>{val.last_attempt ? moment(val.last_attempt).format('YYYY-MM-DD HH-mm:ss') : ''}</td>
                      <td>{val.is_success ? 'Yes' : 'No'}</td>
                      <td><button className='btn btn-xs me-3' onClick={(e) => { openForm(val.id, e) }}><i className='fa fa-pen-to-square'></i></button> </td>
                    </tr>)
                })}
              </tbody>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
      </Panel>
      <>
        <Modal
          isOpen={formIsOpen}
          onAfterOpen={() => { }}
          onRequestClose={() => setFormIsOpen(false)}
          style={customStyles}
          ariaHideApp={false}  >
          <OutboundIntegrationForm props={{
            uid: modalUid, cancelAction: () => {
              setFormIsOpen(false)
            }
          }} />
        </Modal>

      </>


    </div>
  )
}

export default OutboundIntegrationLog;